<template>
  <v-container fluid>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab>About</v-tab>
      <v-tab>Contact</v-tab>
      <v-tab>Social Media</v-tab>
    </v-tabs>

    <v-tabs-window v-model="tab">
      <v-tabs-window-item>
        <v-card class="mx-auto my-4 modern-card" max-width="1200">
          <v-row no-gutters>
            <v-col cols="12" md="4" class="d-flex justify-center">
              <v-img
                v-if="abouts.length > 0 && abouts[0].image"
                :src="getImageUrl(abouts[0].image)"
                alt="About Image"
                class="company-logo"
                max-width="100%"
                max-height="100%"
              ></v-img>
            </v-col>

            <v-col cols="12" md="8" class="pa-4 text-left">
              <v-card-title class="text-h3" style="color: #002250;">{{currentAbout.title}}</v-card-title>
              <v-card-text class="text-h6 " style="color: #002250;white-space: normal;text-align: justify;" v-if="abouts.length > 0">
                <div v-html="abouts[0].text.replace(/\n/g, '<br>')"></div>
                
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="mx-auto my-4" persistent scrollable>
  <v-toolbar>
    <v-toolbar-title><strong>Add / Update About</strong></v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
  <v-card-text>
    <v-form ref="aboutForm" v-model="valid">
      <v-text-field
        variant="outlined"
        v-model="currentAbout.title"
        label="Title"
        required
        :rules="[v => !!v || 'Title is required']"
      ></v-text-field>
      <v-textarea
        variant="outlined"
        v-model="currentAbout.text"
        label="Text"
        required
        :rules="[v => !!v || 'Text is required']"
      ></v-textarea>
      <v-file-input
        variant="outlined"
        v-model="currentAbout.image"
        label="Image"
        accept="image/*"
        @change="onImageChange"
      ></v-file-input>
    </v-form>
  </v-card-text>
  <v-card-actions class="justify-end">
    <div class="text-center">
      <v-btn
        prepend-icon="mdi-check-circle"
        @click="saveAbout"
        variant="flat"
        color="primary"
      >
        Save
      </v-btn>
    </div>
  </v-card-actions>
</v-card>

      </v-tabs-window-item>

      <!-- Contact Section -->
      <v-tabs-window-item>
        <v-card class="mx-auto my-4" >
          <v-card-title>Contact Information</v-card-title>
          <v-card-text>
            <div>
              <v-row>
                <v-col>
                  <p><strong>Address:</strong> {{ contact.address }}</p>
                  <p><strong>Phone 1:</strong> {{ contact.phone_1 }}</p>
                  <p><strong>Phone 2:</strong> {{ contact.phone_2 }}</p>
                  <p><strong>Email:</strong> {{ contact.email }}</p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>

        <!-- CRUD Form for Contact -->
        <v-card class="mx-auto my-4" max-width="600" persistent scrollable>
  <v-toolbar>
    <v-toolbar-title><strong>Add / Update Contact</strong></v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
  <v-card-text>
    <v-form ref="contactForm" v-model="validContact">
      <v-text-field
        variant="outlined"
        v-model="contactForm.address"
        label="Address"
      ></v-text-field>
      <v-text-field
      variant="outlined"
        v-model="contactForm.phone_1"
        label="Phone 1"
      ></v-text-field>
      <v-text-field
      variant="outlined"
        v-model="contactForm.phone_2"
        label="Phone 2"
      ></v-text-field>
      <v-text-field
      variant="outlined"
        v-model="contactForm.email"
        label="Email"
        type="email"
      ></v-text-field>
    </v-form>
  </v-card-text>
  <v-card-actions class="justify-end">
    <div class="text-center">
      <v-btn
        prepend-icon="mdi-check-circle"
        @click="saveContact"
        variant="flat"
        color="primary"
      >
        Save
      </v-btn>
    </div>
  </v-card-actions>
</v-card>

      </v-tabs-window-item>

      <!-- Social Media -->
      <v-tabs-window-item>
        <!-- Social Media Section -->
        <v-card class="mx-auto my-4">
          <v-card-title>Social Media</v-card-title>
              <v-alert
                density="compact"
                text="Display Name pada Whatsapp dapat diisi Admin 1 (08XXXX) atau Admin 1 atau 08xxxxxxx. 
                Ketika diklik, akan otomatis ke redirect menuju Whatsapp"
                title="Informasi"
              ></v-alert>
              <v-alert
                density="compact"
                text="Format URL pada isian Whatsapp
                https://api.whatsapp.com/send/?phone=62XXXXXXXXX&text=&type=phone_number&app_absent=0"
              ></v-alert>
          <v-card-text>
            <v-list>
              <v-list-item v-for="social in socialMedia" :key="social.socmed_id">
                <template v-slot:prepend>
                  <v-icon>{{ social.icon }}</v-icon>
                </template>
                <v-list-item-content>
                  <v-list-item-title class="my-4">{{ social.platform }}</v-list-item-title>
                  <v-text-field
                    v-model="social.username"
                    label="Display Name"
                    variant="outlined"
                  ></v-text-field>
                  <v-text-field
                    v-model="social.socialmedia_url"
                    label="URL"
                    variant="outlined"
                  ></v-text-field>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    color="primary"
                    @click="saveSocialMedia(social)"
                    :loading="social.loading"
                  >
                    Save
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-tabs-window-item>
    </v-tabs-window>

    <v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      tab: '',
      abouts: [],
      socialMedia: [],
      loading: false,
      dialog: false,
      editMode: false,
      currentAbout: {
        about_id: '',
        title: '',
        text: '',
        image: '',
      },
      contact: {},
      contactForm: {
        address: '',
        phone_1: '',
        phone_2: '',
        email: '',
      },
      valid: false,
      snackbar: {
        visible: false,
        message: "",
        timeout: 5000,
      },
    };
  },
  methods: {
    showSnackbar(message, timeout = 3000) {
      this.snackbar.message = message;
      this.snackbar.timeout = timeout;
      this.snackbar.visible = true;
    },
    getImageUrl(imageName) {
      return `${this.$urlImage}storage/images/${imageName}`;
    },
    async fetchAbouts() {
      this.loading = true;
      try {
        const response = await this.$axios.get('/about', {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
          },
        });
        this.abouts = response.data.data || [];
        if (this.abouts.length > 0) {
          this.currentAbout = { ...this.abouts[0] };
        }
      } catch (error) {
        console.error('Error fetching abouts:', error);
      } finally {
        this.loading = false;
      }
    },
    async fetchContact() {
    this.loading = true;
    try {
        const response = await this.$axios.get('/contact', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            },
        });

        // Assign object directly
        this.contact = response.data.data || {}; 

        // Populate contactForm with fetched data
        this.contactForm = {
            address: this.contact.address || '',
            phone_1: this.contact.phone_1 || '',
            phone_2: this.contact.phone_2 || '',
            email: this.contact.email || '',
        };
    } catch (error) {
        console.error('Error fetching contact:', error);
    } finally {
        this.loading = false;
    }
},

    async saveAbout() {
      const formData = new FormData();
      formData.append('title', this.currentAbout.title);
      formData.append('text', this.currentAbout.text);
      
      // Only append image if a new one is selected
      if (this.currentAbout.image && typeof this.currentAbout.image == 'object') {
        formData.append('image', this.currentAbout.image);
      }

      try {
        const action = this.currentAbout.about_id ? 'update' : 'store';
        const url = action == 'update' ? `/about/${this.currentAbout.about_id}` : '/about';
        
        await this.$axios.post(url, formData, {
          headers: { 
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
          },
        });
        await this.fetchAbouts();
        this.showSnackbar('About successfully saved')
      } catch (error) {
        this.showSnackbar('Error while saving')
      }
    },

    async saveContact() {
      try {
        const action = this.contact.contact_id ? 'update' : 'store';
        const url = action == 'update' ? `/contact/${this.contact.contact_id}` : '/contact';

        await this.$axios.post(url, this.contactForm, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
          },
        });
        await this.fetchContact();
        this.showSnackbar('Contact saved successfully')
      } catch (error) {
        this.showSnackbar('Error saving contact')
      }
    },
    onImageChange(event) {
      const file = event.target.files[0];
      this.currentAbout.image = file ? file : '';
    },
    async fetchSocialMedia() {
      try {
        const response = await this.$axios.get('/social-media', {
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
        });
        this.socialMedia = response.data.data || [];
      } catch (error) {
        console.error('Error fetching social media:', error);
      }
    },
    async saveSocialMedia(social) {
      social.loading = true; // Start loading state

      try {
        await this.$axios.post(`/social-media/${social.socmed_id}`, social, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        });

        this.showSnackbar(`${social.platform} updated successfully`);
      } catch (error) {
        this.showSnackbar(`Error updating ${social.platform}`);
      } finally {
        social.loading = false; // Stop loading state
      }
    },
  },
  async created() {
    await this.fetchAbouts();
    await this.fetchContact();
    await this.fetchSocialMedia();
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
